import React from 'react';
import { Flex, Typography } from 'antd';
import { usePluginContext } from '../../../PermissionsContext/usePluginContext';
import { PluginTFunction } from '../../../utils';
import { PermissionName } from '../../constants';

interface TooltipContentProps {
	availablePermissions: string[];
}

const { Link: TypographyLink } = Typography;

const ViewOnlyAndWatermarkTooltipContent: React.FC<{ t: PluginTFunction }> = ({ t }) => {
	return (
		<>
			{t('AccessOptions.tooltips.viewOnly')}
			<Flex>
				<TypographyLink
					href="https://docs.sharefile.com/en-us/sharefile/sharefile-app/sharefile-web/watermark.html"
					target="_blank"
				>
					{t('AccessOptions.tooltips.aboutWatermarkingLink')}
				</TypographyLink>
			</Flex>
		</>
	);
};

const EditTooltipContent: React.FC<{ t: PluginTFunction }> = ({ t }) => {
	return (
		<>
			{t('AccessOptions.tooltips.edit_tooltip')}
			<Flex>
				<TypographyLink
					href="https://docs.sharefile.com/en-us/sharefile/sharefile-app/sharefile-web/co-editing"
					target="_blank"
				>
					{t('AccessOptions.tooltips.edit_about_link')}
				</TypographyLink>
			</Flex>
		</>
	);
};

export const ConditionalTooltipContent: React.FC<TooltipContentProps> = ({
	availablePermissions,
}) => {
	const { t } = usePluginContext();

	if (availablePermissions.includes(PermissionName.Edit)) {
		return (
			<ul>
				<li>
					<ViewOnlyAndWatermarkTooltipContent t={t} />
				</li>
				<li>
					<EditTooltipContent t={t} />
				</li>
			</ul>
		);
	}

	return (
		<li>
			<ViewOnlyAndWatermarkTooltipContent t={t} />
		</li>
	);
};
